import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'hyphenate'})
export class HyphenatePipe implements PipeTransform {
  transform(input: string): string {
    return input.replace(/ /g, '-');
  }
}
